import {getApiBase} from '../config/apiBase';
import {fetchWithNetworkRetries} from './fetchRetry';
import {observeServiceBootIdFromResponse} from './serviceEpochStorage';

function resolveRequestUrl(input) {
    if (typeof input === 'string') {
        return input;
    }
    if (input instanceof Request) {
        return input.url;
    }
    if (input && typeof input.url === 'string') {
        return input.url;
    }
    return null;
}

export function isDashApiRequest(input) {
    const url = resolveRequestUrl(input);
    if (!url) {
        return false;
    }
    if (url.startsWith('/api/') || url === '/api') {
        return true;
    }
    const apiBase = getApiBase().replace(/\/$/, '');
    return url.startsWith(`${apiBase}/`) || url === apiBase;
}

/**
 * Wrap window.fetch with:
 * - transient network / gateway retries (2 extra attempts) before callers see failure
 * - dash-api bootId observation so a JVM restart forces sign-out
 */
export function installDashApiFetchGuard() {
    if (typeof window === 'undefined' || window.__dashApiFetchGuardInstalled) {
        return;
    }
    window.__dashApiFetchGuardInstalled = true;

    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
        const response = await fetchWithNetworkRetries(nativeFetch, args);
        if (isDashApiRequest(args[0])) {
            await observeServiceBootIdFromResponse(response, {trigger: 'fetch'});
        }
        return response;
    };
}

export function getDashApiHealthUrl() {
    return `${getApiBase().replace(/\/$/, '')}/health`;
}
